import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { checkPaidOrders } from 'Redux/ducks/orders';
import AccountDelete from 'Components/Account/LoginAndSecurity/AccountDelete';

function AccountDeleteContainer({ auth }) {
  const [userCanDeleteAccount, setUserCanDeleteAccount] = useState(true);

  useEffect(() => {
    const checkOrdersStatus = async () => {
      const data = await checkPaidOrders();
      setUserCanDeleteAccount(data.success);
    };

    checkOrdersStatus();
  }, []);

  return (
    <AccountDelete auth={auth} userCanDeleteAccount={userCanDeleteAccount} />
  );
}

const mapStateToProps = ({
  auth,
}) => ({
  auth,
});

export default connect(mapStateToProps)(injectIntl(AccountDeleteContainer));
